function updatePrice(selectElement) {
    // Retrieving the selected option's price
    var selectedOption = selectElement.options[selectElement.selectedIndex];
    var price = selectedOption.getAttribute("data-price");

    // Locating the price display element and updating its content
    var productItem = selectElement.closest('.ProductItem');
    if (productItem) {
        var priceDisplay = productItem.querySelector('.ProductItem__Price');
        if (priceDisplay) {
            priceDisplay.textContent = price;
        } else {
            console.error("Unable to find .ProductItem__Price element within the parent .ProductItem");
        }
    } else {
        console.error("Unable to find parent .ProductItem element");
    }
}

// Define the function outside of DOMContentLoaded so it's accessible elsewhere
function updateCartTotalDirectly() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((data) => {
      const newCartTotalInPence = data.total_price;
      const newCartTotalInPounds = newCartTotalInPence / 100;
      updateGiftMessage(newCartTotalInPounds);
    });
}
function updateGiftMessage(cartTotal) {
  const giftMessageElem = document.getElementById("giftMessage");
  const difference = 50 - cartTotal;

  if (difference > 0) {
    giftMessageElem.textContent = `Fancy a free gift? You're only £${difference.toFixed(
      2
    )} away from qualifying.`;
  } else {
    giftMessageElem.textContent =
      "Congratulations! You qualify for a free gift.";
  }
}

function handleCheckboxChange(checkboxElement) {
  // Get the container with class "height-set"
  var containerDiv = document.querySelector(".height-set");

  // Try to find an existing placeholder within the container
  var existingPlaceholder = containerDiv.querySelector(".placeholder");

  if (checkboxElement.checked) {
    // If the checkbox is checked and a placeholder exists, remove the placeholder
    if (existingPlaceholder) {
      containerDiv.removeChild(existingPlaceholder);
    }
  } else {
    // If the checkbox is unchecked and there's no existing placeholder, create one
    if (!existingPlaceholder) {
      var placeholder = document.createElement("div");
      placeholder.className = "placeholder placeholder-1";
      containerDiv.prepend(placeholder); // Add the placeholder to the beginning of the container
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // Handle adding to cart
  const addToCartButton = document.querySelector('[data-action="add-to-cart"]');
  if (addToCartButton) {
    addToCartButton.addEventListener("click", function () {
      setTimeout(function () {
        updateCartTotalDirectly();
      }, 500);
    });
  }
});
